import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

import rope from '../assets/decoration-rope.png'
import hat from '../assets/decoration-hat.png'
import cactus from '../assets/decoration-cactus.png'
import succulent from '../assets/decoration-succulent.png'

const DECORATIONS = { rope, hat, cactus, succulent }

// Decoration images must be exported with a width of 336px
const DECORATION_WIDTH = 336 / 3

type Name = keyof typeof DECORATIONS

const useStyles = createUseStyles({
  image: {
    width: DECORATION_WIDTH,
  },
})

interface Props {
  decoration: Name
  className?: string
}

export const Decoration: FC<Props> = flowMax(
  addDisplayName('Decoration'),
  addProps(({ decoration }) => ({
    image: DECORATIONS[decoration],
  })),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ image, classes, className }) => (
    <img src={image} alt="" className={cx(classes.image, className)} />
  )
)
